<template>
  <CCard class="mt-5 mb-0 p-4 card-container">
    <CContainer>
      <CRow class="mb-4 justify-content-center">
        <img src="img/mail-box.svg" class="card-image" />
      </CRow>
      <CRow class="justify-content-center mb-2 text-center">
        <h1 class="text-primary font-3xl w-100 mb-3">{{ $t('automation.list.empty.title') }}</h1>
        <p class="w-100 text-gray-500">{{ $t('automation.list.empty.description') }}</p>
        <CButton @click="$router.push({ name: 'automationNew' })" color="primary" class="mt-3">{{ $t('automation.list.empty.button') }}</CButton>
      </CRow>
    </CContainer>
  </CCard>
</template>

<script>
export default {
  name: 'AutomationListEmpty',
}
</script>

<style lang="scss" scoped>
.card-container {
  max-width: 770px;
  margin: auto;
}
</style>
